import { useNavigate } from 'react-router';
import { Icon } from '../components/Icon.js';
import { PageHead } from '../components/ui.js';
import { SETTINGS_TOOLS } from '../modules.js';
import { useSignedIn } from '../session.js';

/**
 * Settings: the administration tools, for admins only. Not a configuration
 * screen: business rules stay in config/portal.json and per-environment
 * values in DigitalOcean (brief section 12).
 */
export function Settings() {
  const { can } = useSignedIn();
  const navigate = useNavigate();
  return (
    <>
      <PageHead
        title="Settings"
        lede="Administration of the portal. Business lists and rules live in the configuration file, not here."
      />
      <div className="list">
        {SETTINGS_TOOLS.filter((t) => t.allowed(can)).map((t) => (
          <button key={t.path} type="button" className="row" onClick={() => navigate(t.path)}>
            <span className="av">
              <Icon name={t.icon} />
            </span>
            <span className="tx">
              <span className="t1">{t.title}</span>
              <span className="t2">{t.text}</span>
            </span>
          </button>
        ))}
      </div>
    </>
  );
}
